export const DELAY = 200; // in ms
